import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@auth/presentation/store/authStore';
import { orgPaths } from '@shared/routes/appPaths';

// Redirige a la ruta correcta según el rol del usuario autenticado
export default function RoleRedirect() {
  const user = useAuthStore((s) => s.user);

  if (user?.role === 'superadmin') {
    return <Navigate to="/admin/organizations" replace />;
  }

  if (user?.organizationSlug) {
    return <Navigate to={orgPaths.myOrganization(user.organizationSlug)} replace />;
  }

  return <Navigate to="/auth/login" replace />;
}
